<div class="card">
  <div class="card-body">
    <spk-search-grid #grid [list]="'CommandSecurityRoleSearchRow'" title="Security Checkpoints" autoload="true" defaultSortProperty="CommandName, Role" showSearch="true"
      [leftLinks]="leftLinks" [csvExport]="true">
    </spk-search-grid>
  </div>
</div>